module.exports = __webpack_public_path__ + "img/1-活码设置-02.9168af10.png";